module.exports = __webpack_public_path__ + "static/media/carlous-img1.8739fc90.jpg";